<template>
  <div class="filter-block d-flex align-items-center">

    <span class="mr-2">
      {{lg('',{
        en: 'Category',
        zh: '类别',
      })}}:
    </span>
    <select 
      v-model="on_filter"
      class="form-control c-theme"
      >
      <option :value="''">
        {{lg('',{
          en: 'All',
          zh: '全部',
        })}}
      </option>
      <option 
        v-for="item of list_btn" 
        :key="item.id" 
        :value="item.id"
        >
        {{lg('',item.name)}}
      </option>
    </select>



    <div v-if="0" class="ui-tabset">
      <span>
        <span v-if="on_filter" class="tab cd mr-0 on" style="white-space: nowrap;">
          {{lg('',
            list_btn.find(item => item.id === on_filter).name
          )}}

          <i class="fa fa-times ml-2 cp op5 h-op10" @click.stop="on_filter = ''"></i>
        </span>
        <span 
          v-else 
          class="tab mr-0"
          >
          {{lg('',{
            en: 'Filter',
            zh: '筛选',
          })}}
        </span>
      </span>
    </div>

    <div 
      v-if="0 && !status_hide_nav"
      class="filter-nav-div"
      >
      <div class="navpad py-3">
        <div class="small t-gray px-4">
          {{lg('',{
            en: 'Sort By',
            zh: '排序',
          })}}
        </div>
        <div 
          v-for="item of list_btn" 
          :key="item.id" 
          :class="['nav-item px-4 py-2 cp',{'on': item.id === on_filter}]"
          @click="on_filter = item.id;hidePad()"
          >
          {{lg('',
            item.name
          )}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'btnSortList',
  components: {},
  props: [
    'value',
  ],
  data() {
    return {
      on_filter: '',
      status_hide_nav: false,

      list_btn: [
        {
          id: 'DEGO',
          name: {
            en: 'DEGO',
            zh: '',
          },
        },
        {
          id: 'ALPACA',
          name: {
            en: 'ALPACA',
            zh: '',
          },
        },
        {
          id: 'ALICE',
          name: {
            en: 'ALICE',
            zh: '',
          },
        },
        {
          id: 'BONDLY',
          name: {
            en: 'BONDLY',
            zh: '',
          },
        },
        {
          id: 'JGN',
          name: {
            en: 'JGN',
            zh: '',
          },
        },
        // {
        //   id: 'verified_only',
        //   name: {
        //     en: 'Verified only',
        //     zh: '已验证',
        //   },
        // },
      ],
    }
  },
  computed: {},
  watch: {
    value(val){
      this.on_filter = val
    },
    on_filter(val){
      this.$emit('input',val)
    },
  },
  methods: {
    hidePad(){
      let v = this
      v.status_hide_nav = true
      setTimeout(function(){
        v.status_hide_nav = false
      },500)
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  .filter-block{
    position: relative;
    white-space: nowrap;

    &:hover{
      .filter-nav-div{
        display: block;
      }
    }
    
    .filter-nav-div{
      display: none;
      position: absolute;
      right: 0;
      z-index: 9;

      .navpad{
        width: 200px;
        background-color: var(--bg-color);
        color: var(--text-color);
        border: 2px solid $c_border;
        border-radius: 8px;
        animation: popshow .2s 1;;

        .nav-item{
          &:hover,&.on{
            background-color: rgba($c_border,0.1);
          }
        }
      }

      @keyframes popshow {
        0%{
          opacity: 0;
          transform: scale(0.8);
        }
        80%{
          transform: scale(1.1);
        }
        100%{
          opacity: 1;
          transform: scale(1);
        }
      }
    }
  }
</style>